import { createContext } from 'react'

const barraprincipalContext = createContext();

export default barraprincipalContext;